module.exports = __webpack_public_path__ + "media/images/online_ordering_settings_images/full_banner-3ee9e243f5c4ba5c2729cfdfc0dcc375.png";